"use client";

import type { DeliveryCard } from "@/components/landing/Delivery/types";
import DeliveryBullets from "@/components/landing/Delivery/DeliveryBullets";
import DeliveryCardHeader from "@/components/landing/Delivery/DeliveryCardHeader";
import DeliveryInfoGrid from "@/components/landing/Delivery/DeliveryInfoGrid";
import DeliveryTimeline from "@/components/landing/Delivery/DeliveryTimeline";
import { MotionReveal, SectionHeader, useSectionMotion } from "@/components/landing/shared";

interface DeliveryInnerProps {
	title: string;
	intro: string;
	card: DeliveryCard;
	bullets: string[];
}

function DeliveryInner(prop: DeliveryInnerProps) {
	const { title, intro, card, bullets } = prop;
	const motion = useSectionMotion();
	return (
		<>
			<MotionReveal motion={motion}>
				<SectionHeader
					title={title}
					subtitle={intro}
					wrapperClassName="mx-auto max-w-2xl px-6 text-center"
				/>
			</MotionReveal>

			<MotionReveal motion={motion} delayOffset={120}>
				<div className="mx-auto mt-12 max-w-4xl px-6">
					<div className="card p-6 text-start shadow-(--shadow) sm:p-8">
						<DeliveryCardHeader card={card} />
						<DeliveryTimeline steps={card.steps} />
						<DeliveryInfoGrid card={card} />
					</div>
				</div>
			</MotionReveal>

			<MotionReveal motion={motion} delayOffset={200}>
				<DeliveryBullets bullets={bullets} />
			</MotionReveal>
		</>
	);
}

export default DeliveryInner;
